import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { InsuranceApprovalReceivedDataSchema } from "./insurance-approval-received";

export const SowChangeCarrierApprovalTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_CARRIER_APPROVAL),
  data: InsuranceApprovalReceivedDataSchema,
});
